import React from 'react';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from '@mui/material';
import { CloseRounded as CloseRoundedIcon } from '@mui/icons-material';
import { StyledReferralDialog } from './index.style';

const ReferralPopup = ({
  open,
  onClose,
  title,
  contentComponent,
  actionComponent,
}) => {
  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    onClose();
  };

  return (
    <StyledReferralDialog open={open} onClose={handleClose}>
      <DialogTitle classes={{ root: 'dialog-title' }}>
        <Typography className="title">{title}</Typography>
        <IconButton className="close-icon" onClick={onClose}>
          <CloseRoundedIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent className="dialog-content">
        {contentComponent}
      </DialogContent>
      <DialogActions className="dialog-actions">
        {actionComponent}
      </DialogActions>
    </StyledReferralDialog>
  );
};

export default ReferralPopup;
